var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.68 3.222H4.32a2.194 2.194 0 0 0-2.195 2.195v15.36c0 1.213.982 2.195 2.194 2.195h15.362a2.194 2.194 0 0 0 2.194-2.194V5.417a2.194 2.194 0 0 0-2.194-2.195q0 0 0 0m-3.292-2.194v4.389M7.611 1.028v4.389M2.125 9.805h19.75"
  })));
};
export default SvgIconCalendar;